import { RequestBuilder, authorizedPipe } from 'services/net'
import { LEGACY_URL } from 'config'
import { ContentType } from 'shared'

const ENDPOINT_REQUEUE_POSTS = `${LEGACY_URL}/v3/posts/requeue_v3`

export const V1 = Object.freeze({
  requeuePost: function () {
    return function (
      ids: string[],
      ppids: string[],
      postType: 'posted' | 'failed' | 'archived',
      all?: boolean,
      bucketId?: string,
      query?: string,
      types?: ContentType[],
      startDate?: string,
      endDate?: string
    ) {
      const builder = new RequestBuilder(ENDPOINT_REQUEUE_POSTS).asPost().expectJSON()
      const data: any = {
        type: postType,
        pp_page_ids: ppids
      }

      if (bucketId) {
        data.bucket_id = bucketId
      }

      if (all) {
        data.selected = 'all'
        data.post_ids = []
        // if all is true, pass the date range if provided
        if (startDate && endDate) {
          const start = new Date(startDate)
          const end = new Date(endDate)
          data.date_from = `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()}`
          data.date_to = `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`
        }
      } else {
        data.post_ids = ids
      }
      if (query) {
        data.search = query
      }
      if (types) {
        data.post_types = types.join(',')
      }

      return authorizedPipe<any>(
        builder
          .body(data)
          .build()
      )
    }
  }()
})
